module.exports = __webpack_public_path__ + "static/IMG-20200804-WA0046-b1d351cb83b1be553f2b4f52d1db6986.jpg";